import { FETCH_PRODUCT_REQUESTS } from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {},
};

const productRequestsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRODUCT_REQUESTS:
      return { list: action.payload, others: action.others };
    default:
      return state;
  }
};

export default productRequestsReducer;
